import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import InputField from "../components/textfields/InputField";
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from "uuid";
import pincodeSearch from 'india-pincode-search';
import { API } from '../utils/apiUrls';
import { deepTrimStrings } from '../utils/helpers';
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchWalletBalance, applyDelta } from '../redux/slices/walletSlice';
import PickupAddressModal, { deletePickupAddress, DeleteConfirmModal } from '../components/PickupAddressModal';

// Enhanced Icons Component
const Icons = {
  User: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  Location: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  Package: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
    </svg>
  ),
  Truck: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
    </svg>
  ),
  Receipt: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  ),
  Check: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
    </svg>
  ),
  Phone: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
    </svg>
  ),
  Mail: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  MapPin: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    </svg>
  ),
  Sparkles: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    </svg>
  ),
  Lightning: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
    </svg>
  ),
  Close: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),
  Search: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  ),
  Refresh: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
    </svg>
  ),
};

const CreateForwardOrder = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [loadingPincode, setLoadingPincode] = useState(false);
  const [courierServiceability, setCourierServiceability] = useState([]);
  const [customerLookupResults, setCustomerLookupResults] = useState([])
  const [showCustomerModal, setShowCustomerModal] = useState(false)
  const location = useLocation();
  const cloneFrom = location?.state?.cloneFrom;
  const [draftOrderId, setDraftOrderId] = useState(location?.state?.draftOrderId || null);
  const cloneMode = Boolean(cloneFrom);
  const [savingDraft, setSavingDraft] = useState(false);
  const [draftSuccessModal, setDraftSuccessModal] = useState({ open: false, draftId: null, isUpdate: false });
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    customerDetails: {
      name: "",
      phoneNumber: "",
      email: "",
      address: "",
      city: "",
      state: "",
      pincode: "",
    },
    orderDetails: {
      clientOrderId: "",
      invoiceValue: 0,
      itemDetails: [
        {
          name: "",
          quantity: 1,
          unitPrice: "",
          skuId: "",
          hsnCode: "",
        },
      ]
    },
    packageDetails: {
      weight: "",
      length: "",
      breadth: "",
      height: "",
    },
    courierDetails: {
      courierPartner: "",
      useRecommendation: true,
    },
    paymentMode: "Prepaid",
  });

  const resetForm = () => {
    setFormData({
      customerDetails: {
        name: "",
        phoneNumber: "",
        email: "",
        address: "",
        city: "",
        state: "",
        pincode: "",
      },
      orderDetails: {
        clientOrderId: "",
        invoiceValue: 0,
        itemDetails: [
          {
            name: "",
            quantity: 1,
            unitPrice: "",
            skuId: "",
            hsnCode: "",
          },
        ]
      },
      packageDetails: {
        weight: "",
        length: "",
        breadth: "",
        height: "",
      },
      courierDetails: {
        courierPartner: "",
        useRecommendation: true,
      },
      paymentMode: "Prepaid",
    });

    setStep(1);
    setHighestStepReached(1); // Reset highest step reached
    setResponseData(null);
    setSelectedPickup(null);
    setErrors({});
    setExpandedHSNItems({});
  };

  const [pickupDetails, setPickupDetails] = useState([]);
  const [selectedPickup, setSelectedPickup] = useState(null);
  const [showShippingDetails, setShowShippingDetails] = useState(false);
  const [courierOptions, setCourierOptions] = useState([]);
  const [loadingCouriers, setLoadingCouriers] = useState(false);
  const [errors, setErrors] = useState({});
  const [units, setUnits] = useState({ weight: 'gm', length: 'cm', breadth: 'cm', height: 'cm' });
  const reverseMatcher = /(_B2CREVERSE_|REVERSE_)/i;
  const [highestStepReached, setHighestStepReached] = useState(1); // Track highest step user has reached
  const [expandedHSNItems, setExpandedHSNItems] = useState({}); // Track which items have HSN code expanded

  // Address management state
  const [addrModalOpen, setAddrModalOpen] = useState(false);
  const [addrModalMode, setAddrModalMode] = useState("add"); // "add" | "edit"
  const [addrModalLocation, setAddrModalLocation] = useState(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [pickupToDelete, setPickupToDelete] = useState(null);
  const [deletingPickup, setDeletingPickup] = useState(false);

  // Calculate overall form completion percentage
  const calculateCompletionPercentage = () => {
    let totalFields = 0;
    let filledFields = 0;

    // Step 1: Customer Details (6 required fields)
    const customerFields = [
      formData.customerDetails.name,
      formData.customerDetails.phoneNumber,
      formData.customerDetails.address,
      formData.customerDetails.city,
      formData.customerDetails.state,
      formData.customerDetails.pincode,
    ];
    totalFields += customerFields.length;
    filledFields += customerFields.filter(field => String(field || '').trim() !== '').length;

    // Step 2: Pickup Details (1 field) - only count if actually selected
    totalFields += 1;
    if (selectedPickup && selectedPickup.pickup_address) filledFields += 1;

    // Step 3: Order Details
    // Payment mode - only count if user has interacted (we'll check other order fields)
    // Don't count payment mode separately as it has default value
    
    // Client Order ID (required unless cloneMode)
    if (!cloneMode) {
      totalFields += 1;
      if (String(formData.orderDetails.clientOrderId || '').trim()) filledFields += 1;
    }

    // Invoice Value (required) - only count if > 0 (not default)
    totalFields += 1;
    if (parseFloat(formData.orderDetails.invoiceValue || 0) > 0) filledFields += 1;

    // COD Amount (if COD mode selected)
    if (formData.paymentMode.toUpperCase() === 'COD') {
      totalFields += 1;
      const codAmount = parseFloat(formData.orderDetails.codAmount || -1);
      if (codAmount >= 0 && String(formData.orderDetails.codAmount || '').trim()) filledFields += 1;
    }

    // Item Details (each item has fields: name, skuId, quantity, unitPrice)
    formData.orderDetails.itemDetails.forEach(item => {
      // Item name
      totalFields += 1;
      if (String(item.name || '').trim()) filledFields += 1;

      // SKU (required unless cloneMode)
      if (!cloneMode) {
        totalFields += 1;
        if (String(item.skuId || '').trim()) filledFields += 1;
      }

      // Quantity - only count if > 1 (since 1 is default)
      totalFields += 1;
      const qty = Number(item.quantity || 0);
      if (qty > 1 || (qty === 1 && String(item.quantity || '').trim() && item.name)) {
        // Count as filled if quantity is set AND item has name (user interaction)
        if (String(item.name || '').trim()) filledFields += 1;
      }

      // Unit Price - must be explicitly set
      totalFields += 1;
      const price = String(item.unitPrice || '').trim();
      if (price && Number(item.unitPrice) > 0) filledFields += 1;
    });

    // Step 4: Package Details (4 fields - all optional but count if provided)
    const packageFields = [
      formData.packageDetails.weight,
      formData.packageDetails.length,
      formData.packageDetails.breadth,
      formData.packageDetails.height,
    ];
    totalFields += packageFields.length;
    filledFields += packageFields.filter(field => {
      const val = String(field || '').trim();
      return val !== '' && parseFloat(val) > 0;
    }).length;

    // Step 5: Courier Details - only count if manually selected (not default)
    totalFields += 1;
    // Only count as filled if user has explicitly chosen a courier (manual mode)
    if (!formData.courierDetails.useRecommendation && formData.courierDetails.courierPartner) {
      filledFields += 1;
    } else if (formData.courierDetails.useRecommendation && step >= 5) {
      // Count smart allocation as filled only if user has reached courier step
      filledFields += 1;
    }

    // Calculate percentage
    return totalFields > 0 ? Math.round((filledFields / totalFields) * 100) : 0;
  };

  // Helper: decode JWT and extract username
  const getUsernameFromToken = () => {
    const token = localStorage.getItem('authToken');
    if (!token) return '';
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.username || '';
    } catch (e) {
      return '';
    }
  };

  // Generate random SKU: first 3 letters of username + '-' + 6-digit random
  const generateSkuForItem = (index) => {
    const username = getUsernameFromToken();
    const prefix = username.slice(0, 3).toUpperCase();
    const randomSix = Math.floor(100000 + Math.random() * 900000);
    const newSku = `${prefix}-${randomSix}`;
    handleItemChange(index, 'skuId', newSku);
  };

  // ---Gen-ID helper ---
  const handleGenerateOrderId = () => {
    setFormData((f) => ({
      ...f,
      orderDetails: {
        ...f.orderDetails,
        clientOrderId: uuidv4(),
      },
    }));
  };

  // --- fetchSKUDetails populates name/price/quantity + package dims ---
  const fetchSKUDetails = async (index, sku) => {
    if (!sku) return;
    try {
      const authToken = localStorage.getItem('authToken');
      const merchantId = localStorage.getItem('merchantId');
      const skuUrl = API.getProductSku(merchantId, sku);

      const response = await axios.get(skuUrl, {
        headers: { Authorization: authToken },
        validateStatus: () => true,
      });

      const data = typeof response.data === 'object' && response.data !== null ? response.data : null;
      if (!data || Object.keys(data).length === 0) {
        toast.error('Empty product data received for SKU.');
        return;
      }

      const weightObj = data.product_product_sku_master_item_weight ?? data.product_weight ?? data.product_product_weight ?? null;

      // Safely extract fields with fallbacks to current values
      setFormData((prev) => {
        const items = [...prev.orderDetails.itemDetails];
        const currentItem = items[index] || {};

        const productName = (data.product_name ?? currentItem.name) || '';
        const unitPrice = (data.item_pricing_value?.unit_price ?? currentItem.unitPrice) || '';
        const quantity = "1"; // original logic sets to 1 on fetch
        const existingSkuId = currentItem.skuId || '';

        // Dimensions & weight (only update if present)
        const newPackageDetails = { ...prev.packageDetails };
        if (weightObj?.product_weight != null) {
          newPackageDetails.weight = weightObj.product_weight;
        }
        if (data.product_dimensions?.product_length != null) {
          newPackageDetails.length = data.product_dimensions.product_length;
        }
        if (data.product_dimensions?.product_width != null) {
          newPackageDetails.breadth = data.product_dimensions.product_width;
        }
        if (data.product_dimensions?.product_height != null) {
          newPackageDetails.height = data.product_dimensions.product_height;
        }

        const newUnits = { ...units };
        if (data.product_weight?.unit) newUnits.weight = data.product_weight.unit;
        if (data.product_dimensions?.unit) {
          newUnits.length = data.product_dimensions.unit;
          newUnits.breadth = data.product_dimensions.unit;
          newUnits.height = data.product_dimensions.unit;
        }

        items[index] = {
          ...currentItem,
          name: productName,
          unitPrice: unitPrice,
          quantity: quantity,
          skuId: existingSkuId,
        };

        return {
          ...prev,
          orderDetails: { ...prev.orderDetails, itemDetails: items },
          packageDetails: newPackageDetails,
          units: newUnits,
        };
      });
    } catch (err) {
      toast.error('Unable to fetch product details');
    }
  };



  // Conversion functions for payload only
  const convertLength = (value, unit) => {
    const num = parseFloat(value) || 0;
    return unit === 'inch' ? num * 2.54 : num;
  };
  const convertWeight = (value, unit) => {
    const num = parseFloat(value) || 0;
    return unit === 'kg' ? num * 1000 : num;
  };

  const handlePackageValueChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      packageDetails: { ...prev.packageDetails, [field]: value }
    }));
  };
  const handlePackageUnitChange = (field, unit) => {
    setUnits(prev => ({ ...prev, [field]: unit }));
  };

  const handlePincodeChange = async (e) => {
    const pin = e.target.value.trim();
    setFormData(prev => ({
      ...prev,
      customerDetails: { ...prev.customerDetails, pincode: pin }
    }));

    if (!/^\d{6}$/.test(pin)) return;

    setLoadingPincode(true);
    const [entry] = pincodeSearch.search(pin);
    if (entry) {
      setFormData(prev => ({
        ...prev,
        customerDetails: {
          ...prev.customerDetails,
          city: entry.city,
          state: entry.state
        }
      }));
      setLoadingPincode(false);
      return;
    }
    try {
      const response = await axios.get(`https://api.postalpincode.in/pincode/${pin}`);
      const data = response.data?.[0];
      if (data?.Status === 'Success' && data.PostOffice?.length) {
        const postOffice = data.PostOffice[0];
        setFormData(prev => ({
          ...prev,
          customerDetails: {
            ...prev.customerDetails,
            city: postOffice.District,
            state: postOffice.State
          }
        }));
      } else {
        throw new Error('No Postal data');
      }
    } catch (err) {
      toast.error('Invalid PIN Code');
    } finally {
      setLoadingPincode(false);
    }
  };

  useEffect(() => {
    if (step === 1) {
      fetchAndStorePickupDetails();
    }
  }, [step]);

  const fetchAndStorePickupDetails = async ({ skipAutoSelect = false } = {}) => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      return [];
    }

    const parentClientId = localStorage.getItem("parentClientId");
    const apiUrl = `${process.env.REACT_APP_POCAS_BASE_URL}/v1/pocas/onboarding/${parentClientId}/getpickupdetails`;

    try {
      const response = await axios.get(apiUrl, { headers: { Authorization: authToken } });

      if (response.data && response.data.length > 0) {
        localStorage.setItem("pickupLocations", JSON.stringify(response.data));
        setPickupDetails(response.data);
        if (!skipAutoSelect) setSelectedPickup(response.data[0]);
        return response.data;
      } else {
        setPickupDetails([]);
        return [];
      }
    } catch (error) {
      setPickupDetails([]);
      return [];
    }
  };

  useEffect(() => {
    if (step === 2) {
      const tryMatchClonePickup = (addresses) => {
        // If we have cloneFrom pickup data, try to match against saved addresses
        if (!cloneFrom) return false;
        const clonedPostal = (cloneFrom.pickup_pincode || cloneFrom.pickup_postal_code || "").trim();
        const clonedPhone = (cloneFrom.pickup_poc_contact_number || "").trim();
        const clonedAddress = (cloneFrom.pickup_address || "").trim().toLowerCase();

        if (!clonedPostal && !clonedPhone && !clonedAddress) return false;

        // Try to find a matching saved address (by pincode + phone, or pincode + address substring)
        const match = addresses.find((addr) => {
          const addrPostal = (addr.pickup_postal_code || "").trim();
          const addrPhone = (addr.pickup_poc_contact_number || "").trim();
          const addrAddress = (addr.pickup_address || "").trim().toLowerCase();

          if (clonedPostal && addrPostal === clonedPostal) {
            if (clonedPhone && addrPhone === clonedPhone) return true;
            if (clonedAddress && addrAddress.includes(clonedAddress.slice(0, 30))) return true;
          }
          return false;
        });

        if (match) {
          setSelectedPickup(match);
          return true;
        }

        // No match found - auto-open "Add New Address" modal pre-filled with cloned pickup data
        const mappedPickup = {
          pickup_address: cloneFrom.pickup_address || "",
          pickup_city: cloneFrom.pickup_city || "",
          pickup_postal_code: cloneFrom.pickup_pincode || cloneFrom.pickup_postal_code || "",
          pickup_poc: cloneFrom.pickup_name || cloneFrom.pickup_poc || "",
          pickup_organisation: cloneFrom.pickup_organisation || "",
          pickup_poc_contact_number: cloneFrom.pickup_poc_contact_number || "",
          pickup_poc_email: cloneFrom.pickup_poc_email || "",
          pickup_state: cloneFrom.pickup_state || "",
          pickup_district: cloneFrom.pickup_district || "",
          pickup_address_type: cloneFrom.pickup_address_type || "BUSINESS",
          pickup_country_code: cloneFrom.pickup_country_code || "IN",
          pickup_landmark: cloneFrom.pickup_landmark || "",
          gst_number: cloneFrom.pickup_gst_number || cloneFrom.gst_number || "",
        };
        // Only open modal if there's meaningful data to pre-fill
        const hasData = mappedPickup.pickup_postal_code || mappedPickup.pickup_address || mappedPickup.pickup_poc;
        if (hasData) {
          setAddrModalMode("add");
          setAddrModalLocation(mappedPickup);
          setAddrModalOpen(true);
        }
        return false;
      };

      const stored = JSON.parse(localStorage.getItem("pickupLocations") || "[]");
      if (Array.isArray(stored) && stored.length > 0) {
        setPickupDetails(stored);
        if (!tryMatchClonePickup(stored)) {
          setSelectedPickup(stored[0]);
        }
      } else {
        // Fetch with skipAutoSelect so we can try matching first
        fetchAndStorePickupDetails({ skipAutoSelect: true }).then((fetched) => {
          if (fetched && fetched.length > 0) {
            if (!tryMatchClonePickup(fetched)) {
              setSelectedPickup(fetched[0]);
            }
          } else if (cloneFrom) {
            // No saved addresses at all - open add modal with cloneFrom data
            tryMatchClonePickup([]);
          }
        });
      }
    }
  }, [step]);

  /* ── Address management handlers ── */
  const openAddAddress = () => { setAddrModalMode("add"); setAddrModalLocation(null); setAddrModalOpen(true); };
  const openEditAddress = (loc) => { setAddrModalMode("edit"); setAddrModalLocation(loc); setAddrModalOpen(true); };
  const handleAddressSaved = () => {
    fetchAndStorePickupDetails().then((fetched) => {
      // Auto-select the most recently added address (last in list)
      if (fetched && fetched.length > 0) {
        setSelectedPickup(fetched[fetched.length - 1]);
      }
    });
  };
  const openDeleteAddress = (id) => { setPickupToDelete(id); setDeleteConfirmOpen(true); };
  const confirmDeleteAddress = async () => {
    setDeletingPickup(true);
    await deletePickupAddress(pickupToDelete, () => {
      fetchAndStorePickupDetails();
      if (selectedPickup?.pickup_address_id === pickupToDelete) setSelectedPickup(null);
    });
    setDeletingPickup(false);
    setDeleteConfirmOpen(false);
    setPickupToDelete(null);
  };

  const steps = [
    { key: "customerDetails", label: "Customer", icon: Icons.User },
    { key: "pickupDetails", label: "Pickup", icon: Icons.Location },
    { key: "orderDetails", label: "Order", icon: Icons.Receipt },
    { key: "packageDetails", label: "Package", icon: Icons.Package },
    { key: "courierDetails", label: "Courier", icon: Icons.Truck },
    { key: "summary", label: "Success", icon: Icons.Check },
  ];

  const validateStep = () => {
    const currentSection = steps[step - 1].key;

    if (currentSection === "pickupDetails") return true;

    const newErrors = {};
    const addErr = (k, msg) => { newErrors[k] = msg; };

    if (currentSection === "customerDetails") {
      const cd = formData.customerDetails || {};
      if (!String(cd.name || "").trim()) addErr("name", "Name is required");
      if (!/^[0-9]{10}$/.test(String(cd.phoneNumber || ""))) addErr("phoneNumber", "Phone Number must be 10 digits");
      if (!String(cd.address || "").trim()) addErr("address", "Address is required");
      if (!String(cd.city || "").trim()) addErr("city", "City is required");
      if (!String(cd.state || "").trim()) addErr("state", "State is required");
      if (!/^[0-9]{6}$/.test(String(cd.pincode || ""))) addErr("pincode", "Pincode must be 6 digits");
    }

    if (currentSection === "orderDetails") {
      const od = formData.orderDetails || {};

      if (!cloneMode && !String(od.clientOrderId || "").trim()) {
        addErr("clientOrderId", "Client OrderID is required");
      }

      // Invoice Value required and > 0
      const invoiceNum = parseFloat(od.invoiceValue || 0);
      if (!(Number.isFinite(invoiceNum) && invoiceNum > 0)) {
        addErr("invoiceValue", "Invoice Value must be greater than 0");
      }

      if (String(formData.paymentMode || "").toUpperCase() === "COD") {
        const codAmt = parseFloat(od.codAmount ?? "");
        if (!(Number.isFinite(codAmt) && codAmt >= 0)) {
          addErr("codAmount", "CodAmount is required for COD orders");
        }
      }

      // Item-level validations
      (od.itemDetails || []).forEach((item, index) => {
        if (!String(item.name || "").trim()) {
          addErr(`name-${index}`, "Name is required");
        }

        if (!cloneMode) {
          if (!String(item.skuId || "").trim()) {
            addErr(`skuId-${index}`, "SKU ID is required");
          }
        }

        if (!String(item.quantity ?? "").trim() || Number(item.quantity) <= 0) {
          addErr(`quantity-${index}`, "Quantity is required and must be > 0");
        }
        if (!String(item.unitPrice ?? "").trim() || Number(item.unitPrice) < 0) {
          addErr(`unitPrice-${index}`, "Unit Price is required");
        }
      });
    }

    if (currentSection === "packageDetails") {
      const pd = formData.packageDetails || {};

      // Weight validation
      const weightVal = String(pd.weight ?? "").trim();
      if (!weightVal) {
        addErr("weight", "Weight is required");
      } else if (isNaN(Number(weightVal)) || Number(weightVal) <= 0) {
        addErr("weight", "Weight must be a valid number greater than 0");
      }

      // Dimension validations
      const lengthVal = String(pd.length ?? "").trim();
      if (!lengthVal) {
        addErr("length", "Length is required");
      } else if (isNaN(Number(lengthVal)) || Number(lengthVal) <= 0) {
        addErr("length", "Length must be a valid number greater than 0");
      }

      const breadthVal = String(pd.breadth ?? "").trim();
      if (!breadthVal) {
        addErr("breadth", "Breadth is required");
      } else if (isNaN(Number(breadthVal)) || Number(breadthVal) <= 0) {
        addErr("breadth", "Breadth must be a valid number greater than 0");
      }

      const heightVal = String(pd.height ?? "").trim();
      if (!heightVal) {
        addErr("height", "Height is required");
      } else if (isNaN(Number(heightVal)) || Number(heightVal) <= 0) {
        addErr("height", "Height must be a valid number greater than 0");
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleNext = () => {
    if (validateStep()) {
      if (step === 5) {
        handleSubmit();
      } else {
        const nextStep = step === 4 ? 5 : step + 1;
        setStep(nextStep);
        setHighestStepReached(prev => Math.max(prev, nextStep)); // Track highest step reached
        if (step === 4) {
          prefetchCouriersForStep5();
        }
      }
    } else {
    }
  };

  const handleBack = () => {
    setStep(prev => (prev > 1 ? prev - 1 : prev));
  };

  // New function to handle step navigation via step indicators
  const handleStepClick = (targetStep) => {
    // Only allow navigation to steps that have been reached before
    if (targetStep <= highestStepReached && targetStep !== step) {
      setStep(targetStep);
    }
  };

  const handleCourierSelection = async (useRecommendation) => {
    setFormData((prev) => ({
      ...prev,
      courierDetails: {
        ...prev.courierDetails,
        useRecommendation,
        courierPartner: useRecommendation ? "" : prev.courierDetails.courierPartner,
      },
    }));
  };

  const prefetchCouriersForStep5 = async () => {
  try {
    setLoadingCouriers(true);
    await Promise.all([
      fetchCourierPricing(),
      fetchServiceability(),
    ]);
  } finally {
    setLoadingCouriers(false);
  }
};

  const handlePhoneNumberChange = async (e) => {
    const phoneNumber = e.target.value.trim()
    setFormData((prev) => ({
      ...prev,
      customerDetails: { ...prev.customerDetails, phoneNumber },
    }))

    if (/^\d{10}$/.test(phoneNumber)) {
      try {
        const authToken = localStorage.getItem('authToken')
        const merchantId = localStorage.getItem('merchantId')
        const apiUrl = `${process.env.REACT_APP_OMS_BASE_URL}${process.env.REACT_APP_ADDRESS_LOOKUP_FROM_MOBILE_NUMBER}`
        const response = await axios.request({
          method: 'POST',
          url: apiUrl,
          headers: {
            Authorization: authToken,
            'Content-Type': 'application/json',
          },
          data: {
            phone_number: phoneNumber,
            merchant_id: merchantId,
          },
        })

        if (Array.isArray(response.data) && response.data.length > 0) {
          setCustomerLookupResults(response.data)
          setShowCustomerModal(true)
        }
      } catch (err) {
      }
    }
  }

  const selectCustomer = (cust) => {
    setFormData((prev) => ({
      ...prev,
      customerDetails: {
        ...prev.customerDetails,
        name: cust.drop_poc || '',
        phoneNumber: cust.drop_poc_contact_number || prev.customerDetails.phoneNumber,
        email: cust.drop_poc_email || prev.customerDetails.email,
        address: cust.drop_address || '',
        city: cust.drop_city || '',
        state: cust.drop_state || '',
        pincode: cust.drop_postal_code || '',
      },
    }))
    setShowCustomerModal(false)
  }

  const fetchCourierPricing = async () => {
  setLoadingCouriers(true);
  setCourierOptions([]);
  try {
    const allocatedCarriersRaw = JSON.parse(localStorage.getItem("allocatedCarriers") || "[]");
    const merchantId = localStorage.getItem("merchantId");
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      toast.error("Missing authentication.");
      setLoadingCouriers(false);
      return;
    }

    const forwardCarriers = allocatedCarriersRaw
      .map((c) => (typeof c === "string" ? { carrier_partner_id: c } : c))
      .filter(
        (c) =>
          c &&
          typeof c.carrier_partner_id === "string" &&
          !reverseMatcher.test(c.carrier_partner_id) 
      );

    if (!forwardCarriers.length) {
      toast.info("No forward-enabled carriers allocated.");
      setLoadingCouriers(false);
      return;
    }

    const requestPayload = forwardCarriers.map((carrier) => ({
      correlation_id: uuidv4(),
      carrier_partner_id: carrier.carrier_partner_id,
      shipment_type: "FORWARD",
      payment_mode: formData.paymentMode.toUpperCase(),
      invoice_value: parseFloat(formData.orderDetails.invoiceValue),
      rvp_with_quality_check: false,
      weight_in_grams: convertWeight(formData.packageDetails.weight, units.weight),
      length_in_cm: convertLength(formData.packageDetails.length, units.length),
      breadth_in_cm: convertLength(formData.packageDetails.breadth, units.breadth),
      height_in_cm: convertLength(formData.packageDetails.height, units.height),
      pickup_pincode: selectedPickup?.pickup_postal_code,
      drop_pincode: formData.customerDetails.pincode,
    }));

    const response = await axios.post(
      `${process.env.REACT_APP_OMS_BASE_URL}${process.env.REACT_APP_MERCHANT_DOMESTIC_PRICING_BATCH}`,
      requestPayload,
      {
        headers: {
          Authorization: authToken,
          "x-merchant-id": merchantId,
          "Content-Type": "application/json",
        },
      }
    );

    // Deduplicate by carrier_partner_public_name: keep first occurrence only
    const seenNames = new Set();
    const formattedOptions = (response.data || [])
      .filter(rate => !reverseMatcher.test(rate?.carrier_partner_id || ""))
      .filter((rate) => {
        const name = rate.carrier_partner_public_name;
        if (seenNames.has(name)) return false;
        seenNames.add(name);
        return true;
      })
      .map((rate) => ({
        carrier_partner_public_name: rate.carrier_partner_public_name,
        total_amount_charged_after_tax: rate.total_amount_charged_after_tax,
        max_tat_in_days: rate.max_tat_in_days,
      }));

    setCourierOptions(formattedOptions);
  } catch (error) {
    toast.error("Failed to fetch courier rates.");
  } finally {
    setLoadingCouriers(false);
  }
};


  const fetchServiceability = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        toast.error("Missing auth token.");
        return;
      }
      const apiUrl = `${process.env.REACT_APP_OMS_BASE_URL}${process.env.REACT_APP_CHECK_MERCHANT_SERVICEABILITY}`;
      const payload = {
        pickup_pincode: selectedPickup?.pickup_postal_code,
        drop_pincode: formData.customerDetails.pincode,
      };
      const response = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: authToken,
          "Content-Type": "application/json",
        },
      });
      if (
        response.data &&
        response.data.merchant_domestic_serviceabilities &&
        response.data.merchant_domestic_serviceabilities.length > 0
      ) {
        const serviceData = response.data.merchant_domestic_serviceabilities
          .filter(p => !/REVERSE/i.test(p.carrier_partner_id))
          .map(p => ({
            id: p.carrier_partner_id,
            name: (p.carrier_partner_identifier_string || "N/A").trim(),
            prepaid: !!p.prepaid_serviceability_details?.is_serviceable,
            cod: !!p.cod_serviceability_details?.is_serviceable,
          }));
        setCourierServiceability(serviceData);
      } else {
        toast.error("No serviceability data available.");
      }
    } catch (error) {
      toast.error("Failed to fetch serviceability details.");
    }
  };

  const safe = (obj, path, fallback = "") => {
    try {
      return path.split('.').reduce((a, b) => (a && a[b] !== undefined ? a[b] : undefined), obj) ?? fallback;
    } catch {
      return fallback;
    }
  };

  useEffect(() => {
    const cloneFrom = location?.state?.cloneFrom;
    if (!cloneFrom) return;

    const mappedItems = (cloneFrom.shipment_packages ?? [])
      .flatMap(pkg => pkg.items ?? [])
      .map(it => ({
        name: safe(it, 'item_general_details.item_name', ''),
        quantity: safe(it, 'quantity', 1),
        unitPrice: safe(it, 'item_payment_details.unit_price', '') || '',
        skuId: safe(it, 'item_general_details.sku', '') || '',
        hsnCode: safe(it, 'item_general_details.hsn_code', '') || '',
      }));

    const items = mappedItems.length ? mappedItems : [{ name: "", quantity: 1, unitPrice: "", skuId: "", hsnCode: "" }];

    const pm =(safe(cloneFrom, 'payment_details.payment_mode', '') || safe(cloneFrom, 'order_type', '')).toString().toUpperCase();
    const paymentMode = pm === 'COD' ? 'COD' : 'Prepaid';

    const firstPkg =(cloneFrom.shipment_packages && cloneFrom.shipment_packages[0]) || {};
    const packageDims = cloneFrom.shipment_package_dimensions || {};
    const weightInGrams = safe(cloneFrom, 'dead_weight_in_grams', '') || safe(firstPkg, 'weight.value', '');
    const lengthVal = safe(packageDims, 'length', '') || safe(firstPkg, 'dimensions.length', '') || '';
    const breadthVal = safe(packageDims, 'breadth', '') || safe(firstPkg, 'dimensions.breadth', '') || '';
    const heightVal = safe(packageDims, 'height', '') || safe(firstPkg, 'dimensions.height', '') || '';

    const newForm = {
      customerDetails: {
        name: safe(cloneFrom, 'drop_name', ''),
        phoneNumber: safe(cloneFrom, 'drop_poc_contact_number', ''),
        email: safe(cloneFrom, 'drop_poc_email', '') || '',
        address: safe(cloneFrom, 'drop_address', '') || '',
        city: safe(cloneFrom, 'drop_city', '') || '',
        state: safe(cloneFrom, 'drop_state', '') || '',
        pincode: safe(cloneFrom, 'drop_pincode', '') || safe(cloneFrom, 'drop_postal_code', '') || '',
      },
      orderDetails: {
        clientOrderId: uuidv4(),
        invoiceValue: String(safe(cloneFrom, 'payment_details.total_amount', '') || safe(cloneFrom, 'invoice_value', '') || ''),
        itemDetails: items,
        invoiceNumber: safe(cloneFrom, 'invoice_number', '') || '',
        codAmount: pm === 'COD' ? String(safe(cloneFrom, 'payment_details.total_amount', '') || '') : undefined,
      },
      packageDetails: {
        weight: weightInGrams ? String(weightInGrams) : "",
        length: lengthVal ? String(lengthVal) : "",
        breadth: breadthVal ? String(breadthVal) : "",
        height: heightVal ? String(heightVal) : "",
      },
      courierDetails: {
        courierPartner: safe(cloneFrom, 'allocated_carrier_partner_public_name', '') || "",
        useRecommendation: true,
      },
      paymentMode,
    };

    const inferredUnits ={ weight: 'gm', length: 'cm', breadth: 'cm', height: 'cm' };
    // Prefer shipment_package_dimensions.unit, then firstPkg.dimensions.unit
    const dimensionUnit = safe(packageDims, 'unit', '') || safe(firstPkg, 'dimensions.unit', '');
    if (dimensionUnit) {
      inferredUnits.length = dimensionUnit;
      inferredUnits.breadth = dimensionUnit;
      inferredUnits.height = dimensionUnit;
    }
    const weightUnit =safe(firstPkg, 'weight.unit', '') || (cloneFrom.product_weight && cloneFrom.product_weight.unit) || '';
    if (weightUnit) inferredUnits.weight = weightUnit;

    // optionally set selectedPickup based on pickup fields in shipment
    const mappedPickup = {
      pickup_address: safe(cloneFrom, 'pickup_address', ''),
      pickup_city: safe(cloneFrom, 'pickup_city', ''),
      pickup_postal_code: safe(cloneFrom, 'pickup_pincode', '') || safe(cloneFrom, 'pickup_postal_code', ''),
      pickup_poc: safe(cloneFrom, 'pickup_name', '') || safe(cloneFrom, 'pickup_poc', ''),
      pickup_organisation: safe(cloneFrom, 'pickup_organisation', '') || '',
      pickup_poc_contact_number: safe(cloneFrom, 'pickup_poc_contact_number', ''),
      pickup_poc_email: safe(cloneFrom, 'pickup_poc_email', ''),
      pickup_state: safe(cloneFrom, 'pickup_state', ''),
      pickup_district: safe(cloneFrom, 'pickup_district', ''),
      pickup_address_type: safe(cloneFrom, 'pickup_address_type', '') || 'BUSINESS',
      pickup_country_code: safe(cloneFrom, 'pickup_country_code', '') || 'IN',
      pickup_landmark: safe(cloneFrom, 'pickup_landmark', ''),
      gst_number: safe(cloneFrom, 'pickup_gst_number', '') || safe(cloneFrom, 'gst_number', ''),
    };

    setFormData(prev => ({
      ...prev,
      ...newForm
    }));

    setUnits(inferredUnits);
    setSelectedPickup(mappedPickup);
    setStep(1);

  }, [location?.state]);

  const renderStepContent = () => {
    const currentSection = steps[step - 1]?.key;
    if (!currentSection) return null;

    if (loading) {
      return <div className="text-center text-xl font-semibold">⏳ Processing your order...</div>;
    }

    if (step === 1) {
      return (
        <div className="space-y-4 animate-fade-in">
          {/* Header Section with Icon */}
          <div className="flex items-center space-x-2.5 pb-3 border-b border-gray-200">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-md">
              <div className="w-4 h-4 text-white">
                <Icons.User />
              </div>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">Customer Details</h2>
              <p className="text-xs text-gray-500">Enter recipient's information for delivery</p>
            </div>
          </div>

          {/* Contact Information Card */}
          <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl p-3 shadow-sm border border-gray-100">
            <div className="flex items-center space-x-2 mb-2">
              <div className="w-4 h-4 text-gray-600">
                <Icons.Phone />
              </div>
              <h3 className="text-sm font-semibold text-gray-800">Contact Information</h3>
            </div>
            
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
              {/* Phone Number */}
              <div className="relative">
                <label className="block text-xs font-semibold text-gray-700 mb-1">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none">
                    <div className="w-3.5 h-3.5 text-gray-400">
                      <Icons.Phone />
                    </div>
                  </div>
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="\d*"
                    name="phoneNumber"
                    placeholder="10-digit mobile"
                    value={formData.customerDetails.phoneNumber}
                    onChange={handlePhoneNumberChange}
                    className={`w-full pl-9 pr-3 py-1.5 border-2 text-sm ${
                      errors.phoneNumber 
                        ? 'border-red-300 focus:border-red-500 focus:ring-red-200' 
                        : 'border-gray-200 focus:border-blue-500 focus:ring-blue-200'
                    } rounded-lg shadow-sm focus:ring-1 transition-all duration-200 bg-white`}
                  />
                  {formData.customerDetails.phoneNumber && !errors.phoneNumber && formData.customerDetails.phoneNumber.length === 10 && (
                    <div className="absolute inset-y-0 right-0 pr-2 flex items-center">
                      <div className="w-4 h-4 rounded-full bg-green-100 flex items-center justify-center">
                        <div className="w-2.5 h-2.5 text-green-600">
                          <Icons.Check />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {errors.phoneNumber && (
                  <p className="text-red-500 text-xs mt-0.5 flex items-center">
                    <span className="mr-1">⚠</span> {errors.phoneNumber}
                  </p>
                )}
              </div>

              {/* Name */}
              <div className="relative">
                <label className="block text-xs font-semibold text-gray-700 mb-1">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none">
                    <div className="w-3.5 h-3.5 text-gray-400">
                      <Icons.User />
                    </div>
                  </div>
                  <input
                    type="text"
                    name="name"
                    placeholder="Recipient's name"
                    value={formData.customerDetails.name}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        customerDetails: { ...prev.customerDetails, name: e.target.value },
                      }))
                    }
                    onBlur={(e) => setFormData((prev) => ({ ...prev, customerDetails: { ...prev.customerDetails, name: e.target.value.trim() } }))}
                    className={`w-full pl-9 pr-3 py-1.5 border-2 text-sm ${
                      errors.name 
                        ? 'border-red-300 focus:border-red-500 focus:ring-red-200' 
                        : 'border-gray-200 focus:border-blue-500 focus:ring-blue-200'
                    } rounded-lg shadow-sm focus:ring-1 transition-all duration-200 bg-white`}
                  />
                </div>
                {errors.name && (
                  <p className="text-red-500 text-xs mt-0.5 flex items-center">
                    <span className="mr-1">⚠</span> {errors.name}
                  </p>
                )}
              </div>

              {/* Email */}
              <div className="relative">
                <label className="block text-xs font-semibold text-gray-700 mb-1">
                  Email <span className="text-gray-400 text-xs">(Optional)</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none">
                    <div className="w-3.5 h-3.5 text-gray-400">
                      <Icons.Mail />
                    </div>
                  </div>
                  <input
                    type="email"
                    name="email"
                    placeholder="recipient@example.com"
                    value={formData.customerDetails.email}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        customerDetails: { ...prev.customerDetails, email: e.target.value },
                      }))
                    }
                    onBlur={(e) => setFormData((prev) => ({ ...prev, customerDetails: { ...prev.customerDetails, email: e.target.value.trim() } }))}
                    className="w-full pl-9 pr-3 py-1.5 border-2 text-sm border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 rounded-lg shadow-sm transition-all duration-200 bg-white"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Delivery Address Card */}
          <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl p-3 shadow-sm border border-gray-100">
            <div className="flex items-center space-x-2 mb-2">
              <div className="w-4 h-4 text-gray-600">
                <Icons.MapPin />
              </div>
              <h3 className="text-sm font-semibold text-gray-800">Delivery Address</h3>
            </div>

            <div className="space-y-3">
              {/* Complete Address */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">
                  Complete Address <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="address"
                  placeholder="House/Flat No., Building Name, Street, Area, Landmark"
                  value={formData.customerDetails.address}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      customerDetails: { ...prev.customerDetails, address: e.target.value },
                    }))
                  }
                  onBlur={(e) => setFormData((prev) => ({ ...prev, customerDetails: { ...prev.customerDetails, address: e.target.value.trim() } }))}
                  rows="2"
                  className={`w-full px-3 py-1.5 border-2 text-sm ${
                    errors.address 
                      ? 'border-red-300 focus:border-red-500 focus:ring-red-200' 
                      : 'border-gray-200 focus:border-blue-500 focus:ring-blue-200'
                  } rounded-lg shadow-sm focus:ring-1 transition-all duration-200 bg-white resize-none`}
                />
                {errors.address && (
                  <p className="text-red-500 text-xs mt-0.5 flex items-center">
                    <span className="mr-1">⚠</span> {errors.address}
                  </p>
                )}
              </div>

              {/* Location Details Grid - Pincode, City, State in one line */}
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                {/* Pincode */}
                <div className="relative">
                  <label className="block text-xs font-semibold text-gray-700 mb-1">
                    Pincode <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="pincode"
                    placeholder="6-digit pincode"
                    value={formData.customerDetails.pincode}
                    onChange={handlePincodeChange}
                    maxLength="6"
                    className={`w-full px-3 py-1.5 border-2 text-sm ${
                      errors.pincode 
                        ? 'border-red-300 focus:border-red-500 focus:ring-red-200' 
                        : 'border-gray-200 focus:border-blue-500 focus:ring-blue-200'
                    } rounded-lg shadow-sm focus:ring-1 transition-all duration-200 bg-white`}
                  />
                  {loadingPincode && (
                    <p className="text-blue-600 text-xs mt-0.5 flex items-center">
                      <svg className="animate-spin h-3 w-3 mr-1" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Fetching...
                    </p>
                  )}
                  {errors.pincode && (
                    <p className="text-red-500 text-xs mt-0.5 flex items-center">
                      <span className="mr-1">⚠</span> {errors.pincode}
                    </p>
                  )}
                </div>

                {/* City */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1">
                    City <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="city"
                    placeholder="City name"
                    value={formData.customerDetails.city}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        customerDetails: { ...prev.customerDetails, city: e.target.value },
                      }))
                    }
                    onBlur={(e) => setFormData((prev) => ({ ...prev, customerDetails: { ...prev.customerDetails, city: e.target.value.trim() } }))}
                    className={`w-full px-3 py-1.5 border-2 text-sm ${
                      errors.city 
                        ? 'border-red-300 focus:border-red-500 focus:ring-red-200' 
                        : 'border-gray-200 focus:border-blue-500 focus:ring-blue-200'
                    } rounded-lg shadow-sm focus:ring-1 transition-all duration-200 bg-white`}
                  />
                  {errors.city && (
                    <p className="text-red-500 text-xs mt-0.5 flex items-center">
                      <span className="mr-1">⚠</span> {errors.city}
                    </p>
                  )}
                </div>

                {/* State */}
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1">
                    State <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="state"
                    placeholder="State name"
                    value={formData.customerDetails.state}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        customerDetails: { ...prev.customerDetails, state: e.target.value },
                      }))
                    }
                    onBlur={(e) => setFormData((prev) => ({ ...prev, customerDetails: { ...prev.customerDetails, state: e.target.value.trim() } }))}
                    className={`w-full px-3 py-1.5 border-2 text-sm ${
                      errors.state 
                        ? 'border-red-300 focus:border-red-500 focus:ring-red-200' 
                        : 'border-gray-200 focus:border-blue-500 focus:ring-blue-200'
                    } rounded-lg shadow-sm focus:ring-1 transition-all duration-200 bg-white`}
                  />
                  {errors.state && (
                    <p className="text-red-500 text-xs mt-0.5 flex items-center">
                      <span className="mr-1">⚠</span> {errors.state}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Customer Lookup Modal */}
          {showCustomerModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-md animate-fade-in">
              <div className="bg-white w-full max-w-2xl mx-4 rounded-3xl shadow-2xl overflow-hidden transform animate-scale-in">
                {/* Modal Header */}
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-5 flex justify-between items-center">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                      <Icons.Sparkles />
                    </div>
                    <h3 className="text-xl font-bold text-white">
                      Saved Addresses Found
                    </h3>
                  </div>
                  <button
                    onClick={() => setShowCustomerModal(false)}
                    className="p-2 rounded-xl hover:bg-white/10 transition-colors duration-200"
                    aria-label="Close"
                  >
                    <Icons.Close />
                  </button>
                </div>

                {/* Modal Body */}
                <div className="max-h-[70vh] overflow-y-auto p-6 space-y-3">
                  {customerLookupResults.map((cust, i) => (
                    <button
                      key={i}
                      onClick={() => selectCustomer(cust)}
                      className="w-full text-left p-5 rounded-2xl border-2 border-gray-200 hover:border-blue-500 hover:shadow-lg transition-all duration-200 group bg-gradient-to-br from-white to-gray-50"
                    >
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <p className="text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                            {cust.drop_poc}
                          </p>
                          <p className="text-sm text-gray-600 mt-2 leading-relaxed">
                            {cust.drop_address}
                          </p>
                          <div className="flex items-center space-x-4 mt-3 text-xs text-gray-500">
                            <span className="flex items-center">
                              <Icons.MapPin />
                              <span className="ml-1">{cust.drop_city}, {cust.drop_state}</span>
                            </span>
                            <span className="font-semibold">{cust.drop_postal_code}</span>
                          </div>
                        </div>
                        <div className="ml-4 flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 group-hover:bg-blue-600 transition-colors">
                          <svg className="w-5 h-5 text-blue-600 group-hover:text-white transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }

    if (step === 2) {
      return (
        <div className="space-y-6 animate-fade-in">
          {/* Header Section */}
          <div className="flex items-center justify-between pb-4 border-b border-gray-200">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center shadow-lg">
                <Icons.Location />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900">Pickup Location</h2>
                <p className="text-sm text-gray-500 mt-0.5">Select where the order will be collected from</p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              {/* Add New Address */}
              <button
                onClick={openAddAddress}
                className="flex items-center space-x-2 px-4 py-2.5 bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700 text-white rounded-xl shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" /></svg>
                <span className="font-semibold text-sm">Add New</span>
              </button>
              {/* Refresh Button */}
              <button
                onClick={fetchAndStorePickupDetails}
                className="flex items-center space-x-2 px-4 py-2.5 bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-800 hover:to-gray-900 text-white rounded-xl shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105"
              >
                <Icons.Refresh />
                <span className="font-semibold text-sm">Refresh</span>
              </button>
            </div>
          </div>

          {/* Address Management Modal + Delete Confirm */}
          <PickupAddressModal open={addrModalOpen} mode={addrModalMode} location={addrModalLocation} onClose={() => setAddrModalOpen(false)} onSaved={handleAddressSaved} />
          <DeleteConfirmModal open={deleteConfirmOpen} onConfirm={confirmDeleteAddress} onCancel={() => { setDeleteConfirmOpen(false); setPickupToDelete(null); }} deleting={deletingPickup} />

          {/* Pickup Locations */}
          {pickupDetails.length > 0 ? (
            <div className="grid grid-cols-1 gap-4">
              {pickupDetails.map((pickup) => {
                const isSelected = selectedPickup?.pickup_address_id === pickup.pickup_address_id;
                return (
                  <div
                    key={pickup.pickup_address_id}
                    className={`relative p-6 rounded-2xl border-2 transition-all duration-300 cursor-pointer group ${
                      isSelected
                        ? 'border-blue-500 bg-gradient-to-br from-blue-50 to-indigo-50 shadow-lg ring-4 ring-blue-100'
                        : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-md'
                    }`}
                    onClick={() => setSelectedPickup(pickup)}
                  >
                    {/* Selected Badge */}
                    {isSelected && (
                      <div className="absolute -top-3 -right-3">
                        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-lg">
                          <Icons.Check />
                        </div>
                      </div>
                    )}

                    <div className="flex items-start justify-between">
                      {/* Location Details */}
                      <div className="flex-1 space-y-3">
                        <div>
                          <h3 className="text-xl font-bold text-gray-900">{pickup.pickup_organisation}</h3>
                          <p className="text-sm text-gray-500 mt-1">Pickup ID: {pickup.pickup_address_id}</p>
                        </div>

                        <div className="space-y-2">
                          <div className="flex items-start space-x-3">
                            <Icons.MapPin />
                            <p className="text-gray-700 leading-relaxed">
                              {pickup.pickup_address}, {pickup.pickup_city}, {pickup.pickup_district}, {pickup.pickup_state} - <span className="font-semibold">{pickup.pickup_postal_code}</span>
                            </p>
                          </div>

                          <div className="flex items-center space-x-3">
                            <Icons.User />
                            <p className="text-gray-700">{pickup.pickup_poc}</p>
                          </div>

                          <div className="flex items-center space-x-3">
                            <Icons.Phone />
                            <p className="text-gray-700">{pickup.pickup_poc_contact_number}</p>
                          </div>

                          {pickup.pickup_email && (
                            <div className="flex items-center space-x-3">
                              <Icons.Mail />
                              <p className="text-gray-700">{pickup.pickup_email}</p>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Action Buttons */}
                      <div className="ml-4 flex flex-col items-end gap-2">
                        <button
                          onClick={(e) => { e.stopPropagation(); setSelectedPickup(pickup); }}
                          className={`px-6 py-2.5 rounded-xl font-semibold transition-all duration-200 text-sm ${
                            isSelected
                              ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg'
                              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                          }`}
                        >
                          {isSelected ? (
                            <span className="flex items-center space-x-2">
                              <Icons.Check />
                              <span>Selected</span>
                            </span>
                          ) : (
                            'Select'
                          )}
                        </button>
                        <div className="flex items-center gap-1.5">
                          <button
                            onClick={(e) => { e.stopPropagation(); openEditAddress(pickup); }}
                            className="px-3 py-1.5 text-xs font-semibold rounded-lg bg-amber-50 text-amber-700 border border-amber-200 hover:bg-amber-100 transition-all flex items-center gap-1"
                            title="Edit this address"
                          >
                            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
                            Edit
                          </button>
                          <button
                            onClick={(e) => { e.stopPropagation(); openDeleteAddress(pickup.pickup_address_id); }}
                            className="px-3 py-1.5 text-xs font-semibold rounded-lg bg-red-50 text-red-700 border border-red-200 hover:bg-red-100 transition-all flex items-center gap-1"
                            title="Delete this address"
                          >
                            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-16 text-center">
              <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
                <svg className="w-10 h-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
              </div>
              <p className="text-gray-500 text-lg mb-3">No pickup locations found</p>
              <p className="text-gray-400 text-sm mb-4">Add a new pickup address to get started</p>
              <button
                onClick={openAddAddress}
                className="px-6 py-2.5 bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700 text-white rounded-xl shadow-md hover:shadow-lg transition-all font-semibold flex items-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" /></svg>
                Add Pickup Location
              </button>
            </div>
          )}
        </div>
      );
    }

    if (step === 3) {
      return (
        <div className="space-y-3 animate-fade-in">
          {/* Header Section */}
          <div className="flex items-center space-x-2.5 pb-2 border-b border-gray-200">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center shadow-md">
              <div className="w-4 h-4 text-white">
                <Icons.Receipt />
              </div>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">Order Details</h2>
              <p className="text-xs text-gray-500">Configure payment and item information</p>
            </div>
          </div>

          {/* Compact Layout - Payment Mode + Invoice + Order ID */}
          <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl p-3 shadow-sm border border-gray-100">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-3">
              {/* Payment Mode - Compact Radio Buttons */}
              <div className="lg:col-span-4">
                <label className="block text-xs font-semibold text-gray-700 mb-1.5">Payment Mode</label>
                <div className="flex gap-2">
                  {["Prepaid", "COD"].map((mode) => (
                    <label key={mode} className="flex-1 cursor-pointer">
                      <input
                        type="radio"
                        name="paymentMode"
                        value={mode}
                        checked={formData.paymentMode === mode}
                        onChange={(e) => setFormData((prev) => ({ ...prev, paymentMode: e.target.value }))}
                        className="hidden"
                      />
                      <div
                        className={`p-2 rounded-lg border-2 transition-all duration-200 text-center ${
                          formData.paymentMode === mode
                            ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-100'
                            : 'border-gray-200 hover:border-gray-300'
                        }`}
                      >
                        <div className="flex items-center justify-center space-x-1.5">
                          <div
                            className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                              formData.paymentMode === mode ? 'border-blue-600' : 'border-gray-300'
                            }`}
                          >
                            {formData.paymentMode === mode && (
                              <div className="w-2 h-2 bg-blue-600 rounded-full" />
                            )}
                          </div>
                          <span className={`text-sm font-semibold ${formData.paymentMode === mode ? 'text-blue-600' : 'text-gray-700'}`}>
                            {mode}
                          </span>
                        </div>
                      </div>
                    </label>
                  ))}
                </div>
              </div>

              {/* COD Amount (if COD selected) */}
              {formData.paymentMode === "COD" && (
                <div className="lg:col-span-3 animate-fade-in">
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                    COD Amount <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm font-semibold">₹</span>
                    <input
                      type="number"
                      value={formData.orderDetails.codAmount || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          orderDetails: { ...prev.orderDetails, codAmount: e.target.value },
                        }))
                      }
                      className="w-full pl-7 pr-3 py-1.5 border-2 border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 rounded-lg shadow-sm transition-all duration-200 text-sm"
                      placeholder="0.00"
                    />
                  </div>
                  {errors.codAmount && (
                    <p className="text-red-500 text-xs mt-0.5 flex items-center">
                      <span className="mr-1">⚠</span> {errors.codAmount}
                    </p>
                  )}
                </div>
              )}

              {/* Invoice Value */}
              <div className={formData.paymentMode === "COD" ? "lg:col-span-2" : "lg:col-span-4"}>
                <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                  Invoice Value <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm font-semibold">₹</span>
                  <input
                    type="number"
                    value={formData.orderDetails.invoiceValue}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        orderDetails: {
                          ...prev.orderDetails,
                          invoiceValue: e.target.value,
                        },
                      }))
                    }
                    className="w-full pl-7 pr-3 py-1.5 border-2 border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 rounded-lg shadow-sm transition-all duration-200 bg-white text-sm"
                    placeholder="0.00"
                  />
                </div>
                {errors.invoiceValue && (
                  <p className="text-red-500 text-xs mt-0.5">{errors.invoiceValue}</p>
                )}
              </div>

              {/* Client Order ID */}
              <div className={formData.paymentMode === "COD" ? "lg:col-span-3" : "lg:col-span-4"}>
                <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                  Client Order ID {!cloneMode && <span className="text-red-500">*</span>}
                </label>
                <div className="relative">
                  <input
                    type="text"
                    value={formData.orderDetails.clientOrderId}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        orderDetails: { ...prev.orderDetails, clientOrderId: e.target.value },
                      }))
                    }
                    onBlur={(e) => setFormData((prev) => ({ ...prev, orderDetails: { ...prev.orderDetails, clientOrderId: e.target.value.trim() } }))}
                    className="w-full px-3 py-1.5 pr-10 border-2 border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 rounded-lg shadow-sm transition-all duration-200 text-sm"
                    placeholder="Enter or generate ID"
                  />
                  <button
                    type="button"
                    onClick={handleGenerateOrderId}
                    className="absolute right-1 top-1/2 -translate-y-1/2 p-1.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-md text-xs hover:from-blue-700 hover:to-indigo-700 transition-all duration-200"
                    title="Generate ID"
                  >
                    <div className="w-3.5 h-3.5">
                      <Icons.Sparkles />
                    </div>
                  </button>
                </div>
                {errors.clientOrderId && (
                  <p className="text-red-500 text-xs mt-0.5 flex items-center">
                    <span className="mr-1">⚠</span> {errors.clientOrderId}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Item Details Card - Compact */}
          <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl p-3 shadow-sm border border-gray-100">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-sm font-semibold text-gray-800">Items in Order</h3>
              <button
                onClick={addItemDetail}
                className="flex items-center space-x-1.5 px-3 py-1.5 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg text-xs font-semibold hover:from-green-700 hover:to-emerald-700 transition-all duration-200"
              >
                <span className="text-sm">+</span>
                <span>Add Item</span>
              </button>
            </div>

            <div className="space-y-2">
              {formData.orderDetails.itemDetails.map((item, index) => (
                <div key={index} className="p-3 bg-white rounded-lg border-2 border-gray-200 hover:border-gray-300 transition-all duration-200">
                  <div className="flex items-start justify-between mb-2">
                    <h4 className="text-xs font-semibold text-gray-600">Item #{index + 1}</h4>
                    {formData.orderDetails.itemDetails.length > 1 && (
                      <button
                        onClick={() => removeItemDetail(index)}
                        className="p-1 text-red-500 hover:bg-red-50 rounded transition-colors duration-200"
                      >
                        <div className="w-3.5 h-3.5">
                          <Icons.Close />
                        </div>
                      </button>
                    )}
                  </div>

                  <div className="grid grid-cols-1 lg:grid-cols-12 gap-2">
                    {/* SKU ID */}
                    <div className="lg:col-span-3">
                      <label className="block text-xs font-semibold text-gray-700 mb-1">
                        SKU ID {!cloneMode && <span className="text-red-500">*</span>}
                      </label>
                      <div className="relative">
                        <input
                          type="text"
                          value={item.skuId}
                          onChange={(e) => {
                            const val = e.target.value;
                            setFormData((prev) => {
                              const items = [...prev.orderDetails.itemDetails];
                              items[index] = { ...items[index], skuId: val };
                              return { ...prev, orderDetails: { ...prev.orderDetails, itemDetails: items } };
                            });
                          }}
                          onBlur={(e) => {
                            const trimmed = e.target.value.trim();
                            setFormData((prev) => {
                              const items = [...prev.orderDetails.itemDetails];
                              items[index] = { ...items[index], skuId: trimmed };
                              return { ...prev, orderDetails: { ...prev.orderDetails, itemDetails: items } };
                            });
                          }}
                          className="w-full px-2 py-1.5 pr-16 border-2 border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 rounded-lg shadow-sm transition-all duration-200 text-sm"
                          placeholder="SKU"
                        />
                        <div className="absolute right-1 top-1/2 -translate-y-1/2 flex space-x-0.5">
                          <button
                            type="button"
                            onClick={() => fetchSKUDetails(index, item.skuId)}
                            className="p-1 text-blue-600 hover:bg-blue-50 rounded transition-colors duration-200"
                            title="Search SKU"
                          >
                            <div className="w-3.5 h-3.5">
                              <Icons.Search />
                            </div>
                          </button>
                          <button
                            type="button"
                            onClick={() => generateSkuForItem(index)}
                            className="p-1 text-purple-600 hover:bg-purple-50 rounded transition-colors duration-200"
                            title="Generate SKU"
                          >
                            <div className="w-3.5 h-3.5">
                              <Icons.Sparkles />
                            </div>
                          </button>
                        </div>
                      </div>
                      {errors[`skuId-${index}`] && (
                        <p className="text-red-500 text-xs mt-0.5">⚠ {errors[`skuId-${index}`]}</p>
                      )}
                    </div>

                    {/* Item Name */}
                    <div className="lg:col-span-4">
                      <label className="block text-xs font-semibold text-gray-700 mb-1">
                        Item Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={item.name}
                        onChange={(e) => handleItemChange(index, "name", e.target.value)}
                        onBlur={(e) => handleItemChange(index, "name", e.target.value.trim())}
                        className="w-full px-2 py-1.5 border-2 border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 rounded-lg shadow-sm transition-all duration-200 text-sm"
                        placeholder="Product name"
                      />
                      {errors[`name-${index}`] && (
                        <p className="text-red-500 text-xs mt-0.5">⚠ {errors[`name-${index}`]}</p>
                      )}
                    </div>

                    {/* Quantity */}
                    <div className="lg:col-span-2">
                      <label className="block text-xs font-semibold text-gray-700 mb-1">
                        Qty <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        value={item.quantity}
                        onChange={(e) => handleItemChange(index, "quantity", e.target.value)}
                        className="w-full px-2 py-1.5 border-2 border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 rounded-lg shadow-sm transition-all duration-200 text-sm"
                        placeholder="1"
                        min="1"
                      />
                      {errors[`quantity-${index}`] && (
                        <p className="text-red-500 text-xs mt-0.5">⚠ {errors[`quantity-${index}`]}</p>
                      )}
                    </div>

                    {/* Unit Price */}
                    <div className="lg:col-span-3">
                      <label className="block text-xs font-semibold text-gray-700 mb-1">
                        Unit Price <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 text-sm font-semibold">₹</span>
                        <input
                          type="number"
                          value={item.unitPrice}
                          onChange={(e) => handleItemChange(index, "unitPrice", e.target.value)}
                          className="w-full pl-6 pr-2 py-1.5 border-2 border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 rounded-lg shadow-sm transition-all duration-200 text-sm"
                          placeholder="0.00"
                          min="0"
                          step="0.01"
                        />
                      </div>
                      {errors[`unitPrice-${index}`] && (
                        <p className="text-red-500 text-xs mt-0.5">⚠ {errors[`unitPrice-${index}`]}</p>
                      )}
                    </div>
                  </div>

                  {/* Item Total - Compact */}
                  <div className="mt-2 pt-2 border-t border-gray-200">
                    <div className="flex justify-between items-center">
                      <span className="text-xs font-medium text-gray-600">Item Total</span>
                      <span className="text-sm font-bold text-gray-900">
                        ₹{((Number(item.quantity) || 0) * (Number(item.unitPrice) || 0)).toFixed(2)}
                      </span>
                    </div>
                  </div>

                  {/* HSN Code Section - Expandable */}
                  <div className="mt-2 pt-2 border-t border-gray-200">
                    <button
                      type="button"
                      onClick={() => {
                        setExpandedHSNItems(prev => ({
                          ...prev,
                          [index]: !prev[index]
                        }));
                      }}
                      className="flex items-center space-x-1.5 text-xs font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200"
                    >
                      <span className="text-sm">{expandedHSNItems[index] ? "−" : "+"}</span>
                      <span>Add HSN Code</span>
                    </button>
                    
                    {expandedHSNItems[index] && (
                      <div className="mt-2 animate-fade-in">
                        <label className="block text-xs font-semibold text-gray-700 mb-1">
                          HSN Code <span className="text-gray-400 text-xs">(Optional)</span>
                        </label>
                        <input
                          type="text"
                          value={item.hsnCode || ""}
                          onChange={(e) => handleItemChange(index, "hsnCode", e.target.value)}
                          onBlur={(e) => handleItemChange(index, "hsnCode", e.target.value.trim())}
                          className="w-full px-3 py-1.5 border-2 border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 rounded-lg shadow-sm transition-all duration-200 text-sm"
                          placeholder="Enter HSN code"
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Order Total - Compact */}
            <div className="mt-3 p-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg">
              <div className="flex justify-between items-center">
                <span className="text-white text-sm font-semibold">Order Total</span>
                <span className="text-white text-xl font-bold">
                  ₹{Number(formData.orderDetails.invoiceValue || 0).toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          {/* Optional Fields Toggle Buttons - Compact */}
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => setShowShippingDetails((s) => !s)}
              className="flex items-center space-x-1.5 px-3 py-1.5 border-2 border-gray-200 hover:border-blue-500 rounded-lg text-xs font-semibold text-gray-700 hover:text-blue-600 transition-all duration-200"
            >
              <span>{showShippingDetails ? "−" : "+"}</span>
              <span>Invoice Number</span>
            </button>
          </div>

          {/* Invoice Number - Compact */}
          {showShippingDetails && (
            <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl p-3 shadow-sm border border-gray-100 animate-fade-in">
              <label className="block text-xs font-semibold text-gray-700 mb-1.5">Invoice Number</label>
              <input
                type="text"
                value={formData.orderDetails.invoiceNumber || ""}
                onChange={(e) =>
                  setFormData((p) => ({
                    ...p,
                    orderDetails: { ...p.orderDetails, invoiceNumber: e.target.value },
                  }))
                }
                onBlur={(e) => setFormData((p) => ({ ...p, orderDetails: { ...p.orderDetails, invoiceNumber: e.target.value.trim() } }))}
                className="w-full px-3 py-1.5 border-2 border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 rounded-lg shadow-sm transition-all duration-200 text-sm"
                placeholder="Enter invoice number"
              />
            </div>
          )}
        </div>
      );
    }

    if (step === 4) {
      return (
        <div className="space-y-6 animate-fade-in">
          {/* Header Section */}
          <div className="flex items-center space-x-3 pb-4 border-b border-gray-200">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center shadow-lg">
              <Icons.Package />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">Package Details</h2>
              <p className="text-sm text-gray-500 mt-0.5">Specify dimensions and weight for accurate shipping</p>
            </div>
          </div>

          {/* Info Banner */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 p-4 rounded-xl">
            <div className="flex items-start space-x-3">
              <div className="w-5 h-5 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-blue-900">Pro Tip</p>
                <p className="text-xs text-blue-800 mt-1">
                  Accurate dimensions ensure correct shipping charges. Measure the outer packaging dimensions.
                </p>
              </div>
            </div>
          </div>

          {/* Package Dimensions Card */}
          <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl p-6 shadow-sm border border-gray-100">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { key: 'weight', label: 'Weight', placeholder: '500', units: ['gm', 'kg'], icon: '⚖️' },
                { key: 'length', label: 'Length', placeholder: '30', units: ['cm', 'inch'], icon: '↔️' },
                { key: 'breadth', label: 'Breadth', placeholder: '20', units: ['cm', 'inch'], icon: '↕️' },
                { key: 'height', label: 'Height', placeholder: '10', units: ['cm', 'inch'], icon: '↕️' },
              ].map(({ key, label, placeholder, units: unitOptions, icon }) => (
                <div key={key} className="space-y-2">
                  <label className="block text-sm font-semibold text-gray-700">
                    <span className="mr-2">{icon}</span>
                    {label}
                  </label>
                  <div className="flex items-stretch space-x-2">
                    <input
                      type="number"
                      placeholder={placeholder}
                      value={formData.packageDetails[key]}
                      onChange={e => handlePackageValueChange(key, e.target.value)}
                      className={`flex-1 px-3 py-2.5 border-2 ${errors[key] ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-gray-200 focus:border-blue-500 focus:ring-blue-200'} focus:ring-4 focus:ring-opacity-20 rounded-lg shadow-sm transition-all duration-200 bg-white text-sm`}
                    />
                    <select
                      value={units[key]}
                      onChange={e => handlePackageUnitChange(key, e.target.value)}
                      className="px-2 py-2.5 border-2 border-gray-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-200 focus:ring-opacity-20 rounded-lg shadow-sm transition-all duration-200 bg-white font-semibold text-gray-700 text-sm min-w-[60px]"
                    >
                      {unitOptions.map(u => (
                        <option key={u} value={u}>{u}</option>
                      ))}
                    </select>
                  </div>
                  {errors[key] && (
                    <p className="text-xs text-red-500 mt-1 flex items-center gap-1">
                      <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" /></svg>
                      {errors[key]}
                    </p>
                  )}
                </div>
              ))}
            </div>

            {/* Volumetric Weight Info */}
            {formData.packageDetails.length && formData.packageDetails.breadth && formData.packageDetails.height && (
              <div className="mt-4 p-3 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg border border-indigo-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs font-semibold text-indigo-900">Volumetric Weight</p>
                    <p className="text-xs text-indigo-700 mt-0.5">
                      (L × B × H) / 5000
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-lg font-bold text-indigo-900">
                      {(
                        (convertLength(formData.packageDetails.length, units.length) *
                          convertLength(formData.packageDetails.breadth, units.breadth) *
                          convertLength(formData.packageDetails.height, units.height)) /
                        5000
                      ).toFixed(2)}
                      <span className="text-xs ml-1">kg</span>
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Package Preview Visualization */}
          <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl p-4 shadow-sm border border-gray-100">
            <h3 className="text-sm font-semibold text-gray-800 mb-3">Package Preview</h3>
            <div className="flex items-center justify-center p-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg min-h-[160px]">
              <div className="relative">
                {/* 3D Box Illustration */}
                <div
                  className="relative bg-gradient-to-br from-amber-100 to-orange-100 border-4 border-amber-300 rounded-lg shadow-2xl transform rotate-3 transition-all duration-300 hover:rotate-0"
                  style={{
                    width: `${Math.min(150, Math.max(80, Number(formData.packageDetails.length) || 100))}px`,
                    height: `${Math.min(150, Math.max(60, Number(formData.packageDetails.height) || 80))}px`,
                  }}
                >
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Icons.Package />
                  </div>
                  {/* Dimension Labels */}
                  <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-xs font-semibold text-gray-600 whitespace-nowrap">
                    {formData.packageDetails.length || '?'} {units.length}
                  </div>
                  <div className="absolute -right-12 top-1/2 -translate-y-1/2 text-xs font-semibold text-gray-600 whitespace-nowrap">
                    {formData.packageDetails.height || '?'} {units.height}
                  </div>
                  <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-xs font-semibold text-gray-600 whitespace-nowrap">
                    {formData.packageDetails.weight || '?'} {units.weight}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }



    if (step === 6 && responseData) {
      return (
        <div className="space-y-8 animate-fade-in">
          {/* Success Animation */}
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-green-400 to-emerald-600 shadow-2xl mb-4 animate-bounce-slow">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">Order Created Successfully!</h2>
            <p className="text-lg text-gray-600">
              Thank you, <span className="font-semibold text-blue-600">{responseData.username}</span>
            </p>
          </div>

          {/* Order Details Card */}
          <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl p-6 shadow-lg border border-gray-100">
            <div className="flex items-center space-x-3 mb-4 pb-4 border-b border-gray-200">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center">
                <Icons.Receipt />
              </div>
              <h3 className="text-xl font-bold text-gray-900">Order Information</h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <p className="text-sm font-medium text-gray-500">Shipment Order ID</p>
                  <p className="text-lg font-semibold text-gray-900 mt-1">{responseData.shipment_order_id}</p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Order Reference</p>
                  <p className="text-lg font-semibold text-gray-900 mt-1">{responseData.order_reference_number}</p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Waybill Number</p>
                  <p className="text-lg font-semibold text-gray-900 mt-1">{responseData.waybill}</p>
                </div>
              </div>
              <div className="space-y-4">
                <div>
                  <p className="text-sm font-medium text-gray-500">Merchant ID</p>
                  <p className="text-lg font-semibold text-gray-900 mt-1">{responseData.merchant_id}</p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Courier Partner</p>
                  <div className="flex items-center space-x-2 mt-1">
                    <Icons.Truck />
                    <p className="text-lg font-semibold text-blue-600">{responseData.courier_name}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {responseData.label_url && (
              <a
                href={responseData.label_url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center space-x-2 px-6 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
                <span>Shipping Label</span>
              </a>
            )}
            {responseData.commercial_invoice_url && (
              <a
                href={responseData.commercial_invoice_url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center space-x-2 px-6 py-4 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105"
              >
                <Icons.Receipt />
                <span>Invoice</span>
              </a>
            )}
            <button
              onClick={() => navigate("/all-shipments")}
              className="flex items-center justify-center space-x-2 px-6 py-4 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              <span>Dashboard</span>
            </button>
            <button
              onClick={resetForm}
              className="flex items-center justify-center space-x-2 px-6 py-4 bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-800 hover:to-gray-900 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              <span>New Order</span>
            </button>
          </div>

          {/* Celebration Confetti Effect */}
          <div className="text-center text-6xl animate-pulse">
            🎉 🎊 ✨
          </div>
        </div>
      );
    }

    // Step 5: Courier Selection
    return (
      <div className="space-y-6 animate-fade-in">
        {/* Header Section */}
        <div className="flex items-center space-x-3 pb-4 border-b border-gray-200">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shadow-lg">
            <Icons.Truck />
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-900">Select Courier</h2>
            <p className="text-sm text-gray-500 mt-0.5">Choose your preferred delivery partner</p>
          </div>
        </div>

        {/* Courier Selection Mode */}
        <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl p-6 shadow-sm border border-gray-100">
          <label className="block text-lg font-semibold text-gray-800 mb-4">Selection Mode</label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <label className="relative cursor-pointer group">
              <input
                type="radio"
                name="courierOption"
                checked={formData.courierDetails.useRecommendation}
                onChange={() => handleCourierSelection(true)}
                className="hidden"
              />
              <div
                className={`p-6 rounded-xl border-2 transition-all duration-200 ${
                  formData.courierDetails.useRecommendation
                    ? 'border-blue-500 bg-gradient-to-br from-blue-50 to-indigo-50 shadow-md ring-4 ring-blue-100'
                    : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
                }`}
              >
                <div className="flex items-start space-x-3">
                  <div
                    className={`mt-1 w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${
                      formData.courierDetails.useRecommendation ? 'border-blue-600' : 'border-gray-300'
                    }`}
                  >
                    {formData.courierDetails.useRecommendation && (
                      <div className="w-3 h-3 bg-blue-600 rounded-full" />
                    )}
                  </div>
                  <div>
                    <div className="flex items-center space-x-2">
                      <Icons.Lightning />
                      <span className={`text-lg font-semibold ${formData.courierDetails.useRecommendation ? 'text-blue-600' : 'text-gray-700'}`}>
                        Smart Allocation
                      </span>
                    </div>
                    <p className="text-sm text-gray-500 mt-2">
                      Use intelligent routing rules for optimal delivery
                    </p>
                  </div>
                </div>
              </div>
            </label>

            <label className="relative cursor-pointer group">
              <input
                type="radio"
                name="courierOption"
                checked={!formData.courierDetails.useRecommendation}
                onChange={() => handleCourierSelection(false)}
                className="hidden"
              />
              <div
                className={`p-6 rounded-xl border-2 transition-all duration-200 ${
                  !formData.courierDetails.useRecommendation
                    ? 'border-purple-500 bg-gradient-to-br from-purple-50 to-pink-50 shadow-md ring-4 ring-purple-100'
                    : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
                }`}
              >
                <div className="flex items-start space-x-3">
                  <div
                    className={`mt-1 w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${
                      !formData.courierDetails.useRecommendation ? 'border-purple-600' : 'border-gray-300'
                    }`}
                  >
                    {!formData.courierDetails.useRecommendation && (
                      <div className="w-3 h-3 bg-purple-600 rounded-full" />
                    )}
                  </div>
                  <div>
                    <div className="flex items-center space-x-2">
                      <Icons.User />
                      <span className={`text-lg font-semibold ${!formData.courierDetails.useRecommendation ? 'text-purple-600' : 'text-gray-700'}`}>
                        Manual Selection
                      </span>
                    </div>
                    <p className="text-sm text-gray-500 mt-2">
                      Choose a specific courier from available options
                    </p>
                  </div>
                </div>
              </div>
            </label>
          </div>
        </div>

        {/* Courier Options - Only show if manual selection */}
        {!formData.courierDetails.useRecommendation && (
          <div className="space-y-4 animate-fade-in">
            {/* Loading State */}
            {loadingCouriers ? (
              <div className="flex flex-col items-center justify-center py-20">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center mb-4">
                  <svg className="animate-spin h-10 w-10 text-blue-600" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                </div>
                <p className="text-gray-600 text-lg font-semibold">Fetching courier rates...</p>
              </div>
            ) : courierOptions.length > 0 ? (
              <div className="grid grid-cols-1 gap-4">
                {courierOptions.map((option) => {
                  const today = new Date();
                  const deliveryDate = new Date(today);
                  deliveryDate.setDate(today.getDate() + option.max_tat_in_days);
                  // Match by public name (multiple serviceability entries can share same name)
                  const serviceableEntries = courierServiceability.filter(
                    s => s.name === (option.carrier_partner_public_name || "").trim()
                  );
                  const isServiceable =
                    formData.paymentMode.toUpperCase() === "COD"
                      ? serviceableEntries.some(s => s.cod)
                      : serviceableEntries.some(s => s.prepaid);
                  const isSelected = formData.courierDetails.courierPartner === option.carrier_partner_public_name;

                  return (
                    <div
                      key={option.carrier_partner_public_name}
                      className={`p-5 rounded-2xl border-2 transition-all duration-200 cursor-pointer ${
                        isSelected
                          ? 'border-blue-500 bg-gradient-to-br from-blue-50 to-indigo-50 shadow-lg ring-4 ring-blue-100'
                          : 'border-gray-200 hover:border-gray-300 hover:shadow-md bg-white'
                      }`}
                      onClick={() => {
                        if (isServiceable) {
                          setFormData((prev) => ({
                            ...prev,
                            courierDetails: {
                              ...prev.courierDetails,
                              courierPartner: option.carrier_partner_public_name,
                            },
                          }));
                        }
                      }}
                    >
                      <div className="flex items-center justify-between gap-4">
                        {/* Courier Info */}
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center space-x-3 mb-3">
                            <div className={`w-10 h-10 rounded-lg ${isSelected ? 'bg-blue-600' : 'bg-gray-100'} flex items-center justify-center flex-shrink-0`}>
                              <Icons.Truck />
                            </div>
                            <div className="min-w-0">
                              <h3 className="text-base font-bold text-gray-900 truncate">{option.carrier_partner_public_name}</h3>
                              <div className="flex items-center space-x-2 mt-1">
                                {isServiceable ? (
                                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-800">
                                    <Icons.Check />
                                    <span className="ml-1">Serviceable</span>
                                  </span>
                                ) : (
                                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-red-100 text-red-800">
                                    ✗ Not Serviceable
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Courier Details Grid */}
                          <div className="grid grid-cols-3 gap-3">
                            <div className="text-center p-2 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg">
                              <p className="text-lg font-bold text-blue-600">₹{Number(option.total_amount_charged_after_tax).toFixed(2)}</p>
                              <p className="text-xs text-gray-600 mt-0.5">Total Cost</p>
                            </div>
                            <div className="text-center p-2 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg">
                              <p className="text-lg font-bold text-purple-600">{option.max_tat_in_days}</p>
                              <p className="text-xs text-gray-600 mt-0.5">Days</p>
                            </div>
                            <div className="text-center p-2 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg">
                              <p className="text-sm font-bold text-green-600">{deliveryDate.toLocaleDateString('en-IN', { month: 'short', day: 'numeric' })}</p>
                              <p className="text-xs text-gray-600 mt-0.5">Delivery</p>
                            </div>
                          </div>
                        </div>

                        {/* Select Button */}
                        <div className="flex-shrink-0">
                          <button
                            className={`px-6 py-3 rounded-xl font-semibold transition-all duration-200 whitespace-nowrap ${
                              isSelected
                                ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg'
                                : isServiceable
                                ? 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                : 'bg-gray-50 text-gray-400 cursor-not-allowed'
                            }`}
                            disabled={!isServiceable}
                          >
                            {isSelected ? (
                              <span className="flex items-center space-x-2">
                                <Icons.Check />
                                <span>Selected</span>
                              </span>
                            ) : (
                              'Select'
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
                  <Icons.Truck />
                </div>
                <p className="text-gray-500 text-lg">No courier options available</p>
              </div>
            )}
          </div>
        )}

        {/* Info Message for Smart Allocation */}
        {formData.courierDetails.useRecommendation && (
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 p-5 rounded-xl animate-fade-in">
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icons.Lightning />
              </div>
              <div>
                <p className="text-sm font-semibold text-blue-900">Smart Allocation Enabled</p>
                <p className="text-sm text-blue-800 mt-1">
                  Our system will automatically select the best courier based on your allocation rules, pricing, and delivery time.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleItemChange = (index, key, value) => {
    const updatedItems = [...formData.orderDetails.itemDetails];
    updatedItems[index] = { ...updatedItems[index], [key]: value };
    setFormData((prev) => ({
      ...prev,
      orderDetails: {
        ...prev.orderDetails,
        itemDetails: updatedItems,
      },
    }));
  };

  const removeItemDetail = (index) => {
    if (formData.orderDetails.itemDetails.length > 1) {
      const filteredItems = formData.orderDetails.itemDetails.filter((_, idx) => idx !== index);
      setFormData({
        ...formData,
        orderDetails: {
          ...formData.orderDetails,
          itemDetails: filteredItems
        }
      });
    } else {
      toast.error("At least one item must remain.");
    }
  };

  const addItemDetail = () => {
    const newItem = {
      description: "",
      quantity: "",
      unitPrice: "",
      skuId: "",
      hsnCode: "",
    };
    setFormData({
      ...formData,
      orderDetails: {
        ...formData.orderDetails,
        itemDetails: [...formData.orderDetails.itemDetails, newItem]
      }
    });
  };

  const buildApiPayload = (trimmedForm) => {
    return {
      shipment_order_type: "FORWARD",
      process_shipment_order_in_async: false,
      pickup_details: {
        pickup_address: selectedPickup.pickup_address,
        pickup_city: selectedPickup.pickup_city,
        pickup_district: selectedPickup.pickup_district,
        pickup_state: selectedPickup.pickup_state,
        pickup_postal_code: selectedPickup.pickup_postal_code,
        pickup_poc: selectedPickup.pickup_poc,
        pickup_country_code: selectedPickup.pickup_country_code,
        pickup_poc_contact_number: selectedPickup.pickup_poc_contact_number,
        pickup_address_type: selectedPickup.pickup_address_type,
        pickup_poc_email: selectedPickup.pickup_poc_email,
        pickup_organisation: selectedPickup.pickup_organisation,
        pickup_landmark: selectedPickup.pickup_landmark,
        ...((selectedPickup.gst_number || selectedPickup.pickup_gst_number) && String(selectedPickup.gst_number || selectedPickup.pickup_gst_number).trim() && {
          gst_number: String(selectedPickup.gst_number || selectedPickup.pickup_gst_number).trim()
        }),
      },
      drop_details: {
        drop_poc: trimmedForm.customerDetails.name,
        drop_address: trimmedForm.customerDetails.address,
        drop_city: trimmedForm.customerDetails.city,
        drop_country_code: "IN",
        drop_poc_contact_number: trimmedForm.customerDetails.phoneNumber,
        drop_poc_email: trimmedForm.customerDetails.email || "abc@gmail.com",
        drop_state: trimmedForm.customerDetails.state,
        drop_postal_code: trimmedForm.customerDetails.pincode,
      },
      shipment_details: {
        ...(!trimmedForm.courierDetails.useRecommendation && trimmedForm.courierDetails.courierPartner && {
          shipment_carrier_details: {
            carrier_partner_public_name: trimmedForm.courierDetails.courierPartner,
          },
        }),
        order_details: {
          order_type: trimmedForm.paymentMode.toUpperCase(),
          order_reference_number: trimmedForm.orderDetails.clientOrderId,
          order_invoice_details: {
            invoice_value: parseFloat(trimmedForm.orderDetails.invoiceValue),
            invoice_number: trimmedForm.orderDetails.invoiceNumber || null,
            invoice_currency: "INR"
          },
          ...(trimmedForm.paymentMode.toUpperCase() === "COD" && {
            cod_amount_details: {
              value: parseFloat(trimmedForm.orderDetails.codAmount),
              currency: "INR"
            }
          })
        },
        shipment_packages: [
          {
            items: trimmedForm.orderDetails.itemDetails.map(item => {
              const itemGeneralDetails = {
                item_name: item.name,
                sku: item.skuId
              };
              if (item.hsnCode && String(item.hsnCode).trim()) {
                itemGeneralDetails.hsn_code = String(item.hsnCode).trim();
              }
              return {
                item_general_details: itemGeneralDetails,
                quantity: item.quantity,
                item_payment_details: {
                  unit_price: item.unitPrice
                }
              };
            }),
            dimensions: {
              length: convertLength(trimmedForm.packageDetails.length, units.length),
              breadth: convertLength(trimmedForm.packageDetails.breadth, units.breadth),
              height: convertLength(trimmedForm.packageDetails.height, units.height),
              unit: 'cm'
            },
            weight: {
              value: convertWeight(trimmedForm.packageDetails.weight, units.weight),
              unit: "gm"
            }
          }
        ]
      }
    };
  };

  const handleSaveAsDraft = async () => {
    const trimmedForm = deepTrimStrings(formData);
    setFormData(trimmedForm);

    const orderData = buildApiPayload(trimmedForm);

    setSavingDraft(true);
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        navigate("/login");
        return;
      }

      const merchantId = localStorage.getItem("merchantId");
      const draftPayload = {
        order_data: orderData,
        order_source: "UI_PANEL",
        ...(trimmedForm.orderDetails.clientOrderId && {
          title: `Order ${trimmedForm.orderDetails.clientOrderId}`
        }),
      };

      const apiUrl = draftOrderId
        ? API.updateDraftOrder(draftOrderId)
        : API.createDraftOrder();

      const response = draftOrderId
        ? await axios.put(apiUrl, draftPayload, {
            headers: {
              'Authorization': `${authToken}`,
              'Content-Type': 'application/json',
              'merchantId': merchantId
            }
          })
        : await axios.post(apiUrl, draftPayload, {
            headers: {
              'Authorization': `${authToken}`,
              'Content-Type': 'application/json',
              'merchantId': merchantId
            }
          });

      if (response.data.metadata?.success !== false && response.data.draft_order_id) {
        const newDraftId = response.data.draft_order_id;
        // Store the draftOrderId so subsequent saves use update API (not create)
        if (!draftOrderId) setDraftOrderId(newDraftId);
        setDraftSuccessModal({ open: true, draftId: newDraftId, isUpdate: Boolean(draftOrderId) });
      } else if (response.data.metadata?.success) {
        const newDraftId = draftOrderId || response.data.draft_order_id;
        if (!draftOrderId && newDraftId) setDraftOrderId(newDraftId);
        setDraftSuccessModal({ open: true, draftId: newDraftId, isUpdate: Boolean(draftOrderId) });
      } else {
        toast.error(response.data.metadata?.message || "Failed to save draft.");
      }
    } catch (error) {
      const errMsg = error?.response?.data?.metadata?.message || "Error saving draft. Please try again.";
      toast.error(errMsg);
    } finally {
      setSavingDraft(false);
    }
  };

  const handleSubmit = async () => {

    const trimmedForm = deepTrimStrings(formData);
    setFormData(trimmedForm);

    const apiPayload = buildApiPayload(trimmedForm);

    setLoading(true);
    setResponseData(null);

    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        navigate("/login");
        return;
      }


      const merchantId = localStorage.getItem("merchantId");
      const apiUrl = `${process.env.REACT_APP_OMS_BASE_URL}${process.env.REACT_APP_CREATE_ORDER_URL}`;

      const response = await axios.post(apiUrl, apiPayload, {
        headers: {
          'Authorization': `${authToken}`,
          'Content-Type': 'application/json',
          'x-client-id': merchantId
        }
      });

      if (response.data.metadata.success) {
        setResponseData(response.data.result);
        dispatch(fetchWalletBalance());
        new BroadcastChannel('wallet').postMessage('refresh-balance');
        setStep(6);
      } else {
        toast.error("Failed to create order.");
      }
    } catch (error) {
      toast.error('Error submitting the order. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 mt-2">
      <div className="max-w-7xl mx-auto px-2 lg:px-3">
      <div className="max-w-7xl mx-auto">
        {/* Main Card */}
        <div className="bg-white/80 backdrop-blur-xl shadow-xl rounded-2xl overflow-hidden border border-gray-200">
          {/* Enhanced Step Progress Indicator */}
          <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-4 pt-4 pb-2 border-b border-gray-200">
            <div className="flex justify-between items-center max-w-5xl mx-auto">
              {steps.map((stepItem, index) => {
                const Icon = stepItem.icon;
                const stepNumber = index + 1;
                const isActive = step === stepNumber;
                const isCompleted = step > stepNumber;
                const isReachable = stepNumber <= highestStepReached; // Can navigate to any step that's been reached
                const isClickable = isReachable && !isActive; // Can click if reachable and not current

                return (
                  <div key={index} className="flex-1 relative">
                    {/* Connecting Line */}
                    {index < steps.length - 1 && (
                      <div className="absolute top-7 left-1/2 w-full h-1 -z-10">
                        <div
                          className={`h-full transition-all duration-500 ${
                            isCompleted ? 'bg-gradient-to-r from-blue-500 to-indigo-500' : 'bg-gray-200'
                          }`}
                        />
                      </div>
                    )}

                    {/* Step Circle */}
                    <button
                      onClick={() => handleStepClick(stepNumber)}
                      disabled={!isClickable}
                      className={`relative mx-auto flex flex-col items-center transition-all duration-300 ${
                        isClickable ? 'cursor-pointer hover:scale-105' : isActive ? 'cursor-default' : 'cursor-not-allowed opacity-60'
                      }`}
                      title={isClickable ? `Go to ${stepItem.label}` : isActive ? 'Current step' : 'Complete previous steps first'}
                    >
                      <div
                        className={`w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300 ${
                          isActive
                            ? 'bg-gradient-to-br from-blue-500 to-indigo-600 shadow-lg ring-2 ring-blue-200'
                            : isCompleted
                            ? 'bg-gradient-to-br from-green-500 to-emerald-600 shadow-md'
                            : 'bg-white border-2 border-gray-300'
                        }`}
                      >
                        {isCompleted ? (
                          <div className="w-4 h-4 text-white">
                            <Icons.Check />
                          </div>
                        ) : (
                          <div className={`w-4 h-4 ${isActive || isCompleted ? 'text-white' : 'text-gray-400'}`}>
                            <Icon />
                          </div>
                        )}
                      </div>
                      <span
                        className={`mt-1.5 text-xs font-medium transition-colors duration-300 ${
                          isActive
                            ? 'text-blue-600'
                            : isCompleted
                            ? 'text-green-600'
                            : 'text-gray-500'
                        }`}
                      >
                        {stepItem.label}
                      </span>
                    </button>
                  </div>
                );
              })}
            </div>

            {/* Progress Bar */}
            <div className="mt-4 max-w-5xl mx-auto">
              <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 transition-all duration-500 ease-out"
                  style={{ width: `${step === 6 ? 100 : calculateCompletionPercentage()}%` }}
                />
              </div>
              <p className="text-center text-xs text-gray-600 mt-1.5">
                Step {step} of {steps.length} · {step === 6 ? 100 : calculateCompletionPercentage()}% Complete
              </p>
            </div>
          </div>

          {/* Step Content */}
          <div className="p-5">
            {loading ? (
              <div className="flex flex-col items-center justify-center py-20">
                <div className="relative">
                  <div className="w-24 h-24 rounded-full border-4 border-gray-200 border-t-blue-600 animate-spin" />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Icons.Package />
                  </div>
                </div>
                <p className="text-xl font-semibold text-gray-700 mt-6">Processing your order...</p>
                <p className="text-gray-500 mt-2">Please wait while we create your shipment</p>
              </div>
            ) : (
              renderStepContent()
            )}
          </div>

          {/* Navigation Buttons */}
          {!loading && step !== 6 && (
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-5 py-3 border-t border-gray-200">
              <div className="flex justify-between items-center">
                <button
                  disabled={step === 1}
                  onClick={handleBack}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 ${
                    step === 1
                      ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                      : 'bg-white text-gray-700 hover:bg-gray-50 shadow-md hover:shadow-lg border-2 border-gray-200'
                  }`}
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                  <span>Back</span>
                </button>

                {step === 5 ? (
                  <div className="flex items-center space-x-3">
                    {/* Save as Draft Button */}
                    <button
                      onClick={handleSaveAsDraft}
                      disabled={loading || savingDraft}
                      className={`flex items-center space-x-2 px-5 py-2 rounded-lg font-medium text-sm transition-all duration-200 transform ${
                        loading || savingDraft
                          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                          : 'bg-white text-amber-700 border-2 border-amber-400 hover:bg-amber-50 hover:border-amber-500 shadow-md hover:shadow-lg hover:scale-105'
                      }`}
                    >
                      {savingDraft ? (
                        <>
                          <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                          </svg>
                          <span>Saving...</span>
                        </>
                      ) : (
                        <>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                          </svg>
                          <span>{draftOrderId ? "Update Draft" : "Save as Draft"}</span>
                        </>
                      )}
                    </button>

                    {/* Create Order Button */}
                    <button
                      onClick={handleSubmit}
                      disabled={loading || savingDraft}
                      className={`flex items-center space-x-2 px-5 py-2 rounded-lg font-medium text-sm transition-all duration-200 transform ${
                        loading || savingDraft
                          ? 'bg-gray-400 text-gray-700 cursor-not-allowed'
                          : 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white shadow-lg hover:shadow-xl hover:scale-105'
                      }`}
                    >
                      {loading ? (
                        <>
                          <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                          </svg>
                          <span>Processing...</span>
                        </>
                      ) : (
                        <>
                          <span>Create Order</span>
                          <div className="w-4 h-4">
                            <Icons.Check />
                          </div>
                        </>
                      )}
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={handleNext}
                    className="flex items-center space-x-2 px-5 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white rounded-lg font-medium text-sm shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105"
                  >
                    <span>Next</span>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
      {/* Draft Saved Success Modal */}
      {draftSuccessModal.open && ReactDOM.createPortal(
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-scale-in text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-emerald-100 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              {draftSuccessModal.isUpdate ? "Draft Updated!" : "Draft Saved!"}
            </h3>
            <p className="text-gray-600 mb-1">
              {draftSuccessModal.isUpdate
                ? "Your draft order has been updated successfully."
                : "Your order has been saved as a draft."}
            </p>
            <p className="text-xs text-gray-400 font-mono mb-6">{draftSuccessModal.draftId}</p>
            <div className="flex flex-col gap-2">
              <button
                onClick={() => navigate("/draft-orders")}
                className="w-full px-4 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl font-semibold transition-all shadow-lg flex items-center justify-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                Go to Draft Orders
              </button>
              <div className="flex gap-2">
                <button
                  onClick={() => navigate("/orders")}
                  className="flex-1 px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-semibold transition-all flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" /></svg>
                  Orders
                </button>
                <button
                  onClick={() => {
                    setDraftSuccessModal({ open: false, draftId: null, isUpdate: false });
                    navigate("/create-forward-order", { replace: true, state: {} });
                    window.location.reload();
                  }}
                  className="flex-1 px-4 py-2.5 bg-emerald-50 hover:bg-emerald-100 text-emerald-700 rounded-xl font-semibold transition-all flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                  New Order
                </button>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );

}


export default CreateForwardOrder;